import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { RectificatifComponent } from './rectificatif/rectificatif.component';
import { TypeDescMarcheComponent } from './typeDescMarche/type-desc-marche.component';
import { AvisInitialTypeComponent } from './avisInitialType/avis-initial-type.component';
import { FormfnsimpleComponent } from './formfnsimple/formfnsimple.component';
import { Step1Component } from './steps/step1/step1.component';
import { Step3Component } from './steps/step3/step3.component';
import { Step4Component } from './steps/step4/step4.component';
import { Step9Component } from './steps/step9/step9.component';
import { FormfnsimpleCommonModule } from '../common/formfns.module';

@NgModule({
  declarations: [
    TypeCPVClassComponent,
    TypeObjCPVComponent,
    RectificatifComponent,
    TypeDescMarcheComponent,
    AvisInitialTypeComponent,
    FormfnsimpleComponent,
    Step1Component,
    Step3Component,
    Step4Component,
    Step9Component
  ],
  exports: [
    FormfnsimpleComponent,
    Step1Component,
    Step3Component,
    Step4Component,
    Step9Component
  ],
  imports: [CommonModule, ReactiveFormsModule, SharedModule,FormfnsimpleCommonModule],
})
export class FormfnsimpleRectificatifModule {}
